<template>
  <div class="cursor_pointer">
    <nav class="fr-nav" id="header-navigation" role="navigation" aria-label="Menu principal">
      <ul class="fr-nav__list">
        <li class="nav-item" v-for="option in menuOptions" :key="option.value">
          <!-- Disabled / coming soon item -->
          <template v-if="option.disabled">
            <span
              class="fr-nav__link nav-link--disabled"
              :title="option.label + ' — bientôt disponible'"
            >
              {{ option.label }}
              <span class="nav-coming-soon">▾</span>
            </span>
          </template>
          <!-- Dropdown menu for future use -->
          <template v-else-if="option.hasDropdown">
            <button
              class="fr-nav__link nav-dropdown-btn"
              :class="{ 'fr-nav__link--active': option.selected }"
              :aria-expanded="dropdownOpen ? 'true' : 'false'"
              @click="toggleDropdown(option)"
            >
              {{ option.label }}
              <span class="nav-dropdown-arrow" aria-hidden="true"></span>
            </button>
            <ul v-if="dropdownOpen" class="nav-dropdown-menu">
              <li v-for="sub in option.children" :key="sub.value">
                <a
                  class="nav-dropdown-item"
                  :class="{ 'nav-dropdown-item--active': sub.selected }"
                  :href="sub.link"
                  @click.prevent="handleNavigation(sub)"
                >
                  {{ sub.label }}
                </a>
              </li>
            </ul>
          </template>
          <!-- Regular nav links -->
          <a
            v-else
            class="fr-nav__link"
            :class="{
              'fr-nav__link--active': option.selected,
              'nav-link--with-icon': option.icon,
            }"
            target="_self"
            :href="option.link"
            :aria-current="option.selected ? 'page' : undefined"
            :id="'navigation' + option.value"
            :title="option.label"
            @click.prevent="handleNavigation(option)"
          >
            {{ option.label }}
            <span
              v-if="option.icon"
              :class="option.icon"
              aria-hidden="true"
              class="nav-favoris-icon"
            ></span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>


<script>
import router from '../router'
import { getNavigationStructure } from '@/services/csvDataService.js'
import {
  homeRouteName,
  etatEnvironnementRouteName,
  chantiersRouteName,
  dashboardRouteName,
  rechercheRouteName,
} from '@/config/routeNames.js'
import { SECTION_SYNTHESE_SLUG } from '@/utils/sectionUrl.js'

function buildMenuOptions() {
  const base = process.env.VUE_APP_PREFIX_PATH
  const isStaging =
    typeof window !== 'undefined' &&
    window.location.pathname.includes('/staging')
  const stagingPrefix = isStaging ? '/staging' : ''
  const p = String(base || '') + stagingPrefix

  return [
    {
      value: 'accueil',
      label: 'Accueil',
      selected: false,
      link: String(base || '') + stagingPrefix + (stagingPrefix ? '' : '/'),
    },
    {
      value: 'etat-environnement',
      label: "Etat de l'environnement",
      selected: false,
      link: `${p}/etat-environnement?section=${SECTION_SYNTHESE_SLUG}`,
    },
    {
      value: 'chantiers-sectoriels',
      label: 'Chantiers sectoriels',
      selected: false,
      link: `${p}/chantiers?section=${SECTION_SYNTHESE_SLUG}`,
    },
    {
      value: 'recherche',
      label: 'Recherche',
      selected: false,
      link: `${p}/recherche`,
    },
    {
      value: 'favoris',
      label: 'Favoris',
      selected: false,
      icon: 'fr-icon-bookmark-line',
      link: `${p}/favoris`,
    },
  ]
}

export default {
  name: 'NavigationDsfr',
  data() {
    return {
      myrouter: router,
      menuOptions: buildMenuOptions(),
      sectors: [],
      dropdownOpen: false,
    }
  },
  methods: {
    async loadSectors() {
      try {
        const response = await getNavigationStructure('production')
        if (response.status === 'success' && response.data.sectorNames) {
          this.sectors = response.data.sectorNames.filter((s) => s !== 'Synthèse')
        }
      } catch (error) {
        console.error('Error loading sectors:', error)
      }
    },
    slugify(str) {
      return String(str).toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[àâä]/g, 'a')
        .replace(/[éèêë]/g, 'e')
        .replace(/[îï]/g, 'i')
        .replace(/[ôö]/g, 'o')
        .replace(/[ùûü]/g, 'u')
    },
    toggleDropdown(option) {
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdown() {
      this.dropdownOpen = false
    },
    handleNavigation(option) {
      this.closeDropdown()

      if (option.value.startsWith('sector-')) {
        const sectorMatch = option.link.match(/section=([^&]+)/) || option.link.match(/sector=([^&]+)/)
        if (sectorMatch) {
          const raw = decodeURIComponent(sectorMatch[1])
          const isStaging = window.location.pathname.includes('/staging')
          this.myrouter.push({
            name: dashboardRouteName(isStaging),
            query: { section: raw, view: 'sectorial-engagements' }
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error('Navigation error:', err)
          })
        }
      } else if (option.value === 'accueil') {
        const isStaging = window.location.pathname.includes('/staging')
        this.myrouter.push({ name: homeRouteName(isStaging) }).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error('Navigation error:', err)
        })
      } else if (option.value === 'etat-environnement') {
        const isStaging = window.location.pathname.includes('/staging')
        this.myrouter.push({
          name: etatEnvironnementRouteName(isStaging),
          query: { section: SECTION_SYNTHESE_SLUG }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error('Navigation error:', err)
        })
      } else if (option.value === 'chantiers-sectoriels') {
        const isStaging = window.location.pathname.includes('/staging')
        this.myrouter.push({
          name: chantiersRouteName(isStaging),
          query: { section: SECTION_SYNTHESE_SLUG }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error('Navigation error:', err)
        })
      } else if (option.value === 'recherche') {
        const isStaging = window.location.pathname.includes('/staging')
        this.myrouter.push({ name: rechercheRouteName(isStaging) }).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error('Navigation error:', err)
        })
      } else {
        this.myrouter.push({ name: option.value }).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error('Navigation error:', err)
        })
      }

      this.updateActiveFromRoute()
    },
    updateActiveFromRoute() {
      if (!this.$route) return

      const path = this.$route.path
      const query = this.$route.query

      // Reset all
      this.menuOptions.forEach(opt => {
        opt.selected = false
        if (opt.children) opt.children.forEach(c => { c.selected = false })
      })

      if (this.$route.name === 'home' || this.$route.name === 'staging-home') {
        this.setSelected('accueil')
      } else if (
        this.$route.name === 'etat-environnement' ||
        this.$route.name === 'staging-etat-environnement' ||
        (path.includes('dashboard') &&
          (query.view === 'etat-environnement' ||
            query.view === 'general-engagements'))
      ) {
        this.setSelected('etat-environnement')
      } else if (
        this.$route.name === 'chantiers' ||
        this.$route.name === 'staging-chantiers' ||
        (path.includes('dashboard') &&
          (query.view === 'chantiers-sectoriels' ||
            query.view === 'general-chantiers' ||
            query.view === 'chantier'))
      ) {
        this.setSelected('chantiers-sectoriels')
      } else if (path.includes('dashboard')) {
        const sector =
          query.sector ||
          (query.section === SECTION_SYNTHESE_SLUG || !query.section ? 'Synthèse' : null)
        const view = query.view
        if (sector === 'Synthèse' || query.section === SECTION_SYNTHESE_SLUG) {
          if (!view || view === 'about' || view === 'sectorial-engagements') {
            this.setSelected(view === 'sectorial-engagements' ? 'chantiers-sectoriels' : 'accueil')
          } else {
            this.setSelected('chantiers-sectoriels')
          }
        } else if (sector || query.section) {
          this.setSelected('chantiers-sectoriels')
        }
      } else if (
        this.$route.name === 'recherche' ||
        this.$route.name === 'staging-recherche' ||
        path.includes('recherche')
      ) {
        this.setSelected('recherche')
      } else if (path.includes('favoris')) {
        this.setSelected('favoris')
      }
    },
    setSelected(value) {
      const opt = this.menuOptions.find(o => o.value === value)
      if (opt) opt.selected = true
    },
    set_selected_page(page_name) {
      // Legacy compat
      this.updateActiveFromRoute()
    },
    get_name_page() {
      // Legacy compat
      return ''
    }
  },
  created() {
    this.updateActiveFromRoute()
    this.loadSectors()
  },
  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.nav-dropdown-btn') && !e.target.closest('.nav-dropdown-menu')) {
        this.closeDropdown()
      }
    })

    // Watch route changes
    if (this.$route) {
      this.$watch(
        () => ({
          name: this.$route.name,
          sector: this.$route.query.sector,
          section: this.$route.query.section,
          view: this.$route.query.view,
          path: this.$route.path
        }),
        () => {
          this.updateActiveFromRoute()
        },
        { immediate: true, deep: true }
      )
    }

    this.myrouter.afterEach(() => {
      this.updateActiveFromRoute()
    })
  }
}
</script>

<style>
a:hover:not([href]) {
  cursor: pointer;
}

.cursor_pointer {
  cursor: pointer;
}

.fr-nav__list {
  padding-left: 20px;
  display: flex;
  align-items: center;
}

.nav-item {
  margin-left: 17px;
  position: relative;
  list-style: none;
}

@media (max-width: 991px) {
  .fr-nav__list {
    align-items: stretch;
    padding-left: 0;
  }

  .nav-item {
    margin-left: 0;
    width: 100%;
  }

  .fr-nav__link,
  .nav-dropdown-btn {
    text-align: left;
    justify-content: flex-start;
  }

  .nav-link--with-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .nav-link--with-icon .nav-favoris-icon {
    margin-right: 0;
    margin-left: 0.5rem;
    flex-shrink: 0;
  }
}

/* Style pour l'onglet sélectionné */
.fr-nav__link--active,
.fr-nav__link[aria-current="page"] {
  color: var(--text-action-high-blue-france) !important;
  font-weight: 700;
  position: relative;
}

.fr-nav__link--active::after,
.fr-nav__link[aria-current="page"]::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--text-action-high-blue-france);
}

.fr-nav__link--active:hover,
.fr-nav__link[aria-current="page"]:hover {
  color: var(--text-action-high-blue-france-hover) !important;
}

.fr-nav__link--active:hover::after,
.fr-nav__link[aria-current="page"]:hover::after {
  background-color: var(--text-action-high-blue-france-hover);
}

/* Disabled / coming soon nav item - smaller font for Analyse par secteur */
.nav-link--disabled {
  color: #929292 !important;
  cursor: default;
  pointer-events: none;
  font: inherit;
  font-size: 0.8125rem !important;
}

.nav-coming-soon {
  font-size: 0.625rem;
  margin-left: 0.25rem;
  color: #929292;
}

/* Favoris icon - smaller than default (DSFR icons use pseudo-elements, so use transform) */
.nav-favoris-icon {
  margin-right: 0.1rem;
  display: inline-block;
  vertical-align: middle;
  transform: scale(0.7);
  transform-origin: center center;
}

@media (min-width: 992px) {
  .nav-link--with-icon {
    display: inline-flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 0.1rem;
  }

  .nav-link--with-icon .nav-favoris-icon {
    margin-right: 0;
    margin-left: 0;
  }
}

/* Dropdown button */
.nav-dropdown-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font: inherit;
  padding: inherit;
}

.nav-dropdown-arrow {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23161616' d='M12 15.586L6.707 10.293 8.121 8.879 12 12.757l3.879-3.878 1.414 1.414z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: transform 0.2s ease;
}

.nav-dropdown-btn[aria-expanded="true"] .nav-dropdown-arrow {
  transform: rotate(180deg);
}

/* Dropdown menu */
.nav-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 220px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0.5rem 0;
  margin: 0.25rem 0 0;
}

.nav-dropdown-item {
  display: block;
  padding: 0.5rem 1rem;
  color: #3a3a3a;
  text-decoration: none;
  font-size: 0.875rem;
  white-space: nowrap;
}

.nav-dropdown-item:hover {
  background: #f6f6f6;
  color: var(--text-action-high-blue-france);
}

.nav-dropdown-item--active {
  color: var(--text-action-high-blue-france);
  font-weight: 700;
}
</style>
